import * as yup from 'yup';
import { DataTableHtmlFormatter } from '../../../Component/Model/helpers';

const descriptionMaxLength: number = 1000;

export const noteSchema = yup.object({
  NoteText: yup
    .string()
    .max(descriptionMaxLength, 'Description is too long')
    .transform((value, originalValue) => {
      return DataTableHtmlFormatter(originalValue, ' ');
    })
    .required('Description is required')
    .min(1, 'Description is required'),
  ResponsibleUserList: yup
    .array()
    .min(1, 'Please select at least one Responsible Person')
    .required('Please select at least one Responsible Person'),
  InvalidResponsibleUserList: yup
    .array()
    .max(0, 'Please remove all Invalid Responsible People from the list'),
});
